import {
    Transfer,
    Tripleg,
    useFullOpenTransfersForTruck,
    watchLastTriplegForTruckTqo
} from "../rpc/webrpc-client.gen.ts";
import {isTstzFinite} from "../tstzspan.ts";
import {useCallback, useMemo} from "react";
import {z} from "zod/v4";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {useRefreshableInfallibleQuery} from "../util/tqrefresh.tsx";
import {errorize} from "../bomb/errorize.tsx";
import {cleanse, NADA} from "../util/arutil.tsx";
import {useMothership} from "../tq/tqx.tsx";

export const TriplegStatusCode = z.enum([
    "UNKNOWN",
    "EN_ROUTE",
    "AWAITING_ADMISSION",
    "COMPLETE",
]);
export type TriplegStatusCode = z.infer<typeof TriplegStatusCode>;
export const TriplegStatusCodes = TriplegStatusCode.enum;

export const TriplegStatus = z.object({
    code: TriplegStatusCode,
//     isDestinationGuarded: boolean;
});
export type TriplegStatus = z.infer<typeof TriplegStatus>;

export function useTriplegStatus(args?: { tripleg: Tripleg }): InfallibleUseResult<TriplegStatus> {
//    const destinationId = tripleg?.destination.id ?? TQDEADBEEF
    // const enableAutoAdmitCheck = enabled ?? (destinationId !== TQDEADBEEF);
    // const {data: admittersData, isSuccess: isAdmittersSuccess}
    //     = useRefreshableQuery({
    //     ...watchAdmittersOnDutyForVenueTqo({venueId: destinationId}),
    //     enabled: enableAutoAdmitCheck, ...rest
    // });
    const tripleg = args?.tripleg;

    const rv = useMemo(() => {
        // if (enableAutoAdmitCheck && !isAdmittersSuccess) {
        //     return MADA;
        // }
        //

        const code = tripleg
            ? tripleg.admitted
                ? TriplegStatusCodes.COMPLETE
                : tripleg.arrived
                    ? TriplegStatusCodes.AWAITING_ADMISSION
                    : TriplegStatusCodes.EN_ROUTE
            : TriplegStatusCodes.UNKNOWN;

//        const isDestinationGuarded = !isEmpty(admittersData?.admitters);
        return successUseResult({code});

    }, [tripleg]);

    return rv;
}

export const TransferStatus = z.enum([
    "UNKNOWN",
    "ONLOADING",
    "ONLOADED",
    "OFFLOADING",
    "OFFLOADED",
]);
export type TransferStatus = z.infer<typeof TransferStatus>;
export const TransferStatusen = TransferStatus.enum;

export function getTransferStatus(xfer: Transfer | null | undefined): TransferStatus {
    if (!xfer) {
        return TransferStatusen.UNKNOWN;
    }
    if (isTstzFinite(xfer.offloadEnded)) {
        return TransferStatusen.OFFLOADED;
    }
    if (isTstzFinite(xfer.offloadStarted)) {
        return TransferStatusen.OFFLOADING;
    }
    if (isTstzFinite(xfer.onloadEnded)) {
        return TransferStatusen.ONLOADED;
    }
    return TransferStatusen.ONLOADING;
}

export const UseUnfinishedBusinessArgs = z.object({
    truckId: z.string(),
});
export type UseUnfinishedBusinessArgs = z.infer<typeof UseUnfinishedBusinessArgs>;

export function useUnfinishedBusiness(args?: UseUnfinishedBusinessArgs): InfallibleUseResult<Transfer[]> {
    const mama = useMothership();
    const openTransfersTqrv
        = useFullOpenTransfersForTruck(args);
    const lastTriplegTqrv
        = useRefreshableInfallibleQuery(watchLastTriplegForTruckTqo(mama, args));
    const lastTripleg = lastTriplegTqrv.data;
    const whereIsTruck = lastTripleg?.destination;
    const olbtfilter = useCallback((xfer: Transfer) => {
        if (xfer.onloadVenue?.id === whereIsTruck?.id && !!xfer.onloadStarted && !xfer.onloadEnded) {
            return true;
        }
        if (xfer.offloadVenue?.id === whereIsTruck?.id && !!xfer.offloadStarted && !xfer.offloadEnded) {
            return true;
        }
        return false;
    }, [whereIsTruck?.id]);

    if (openTransfersTqrv.isPending || lastTriplegTqrv.isPending) {
        return pendingUseResult;
    }
    if (openTransfersTqrv.isError) {
        throw errorize(openTransfersTqrv.errors);
    }

    const openTransfers = cleanse(openTransfersTqrv.data);
    const openLocalBundleTransfers = whereIsTruck
        ? openTransfers.filter(olbtfilter)
        : NADA;

    return successUseResult(openLocalBundleTransfers);
}


